import { Component, ElementRef, Input, Renderer2, ViewEncapsulation } from '@angular/core';
import { FuseConfigService } from '../../../../@fuse/services/config.service';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarComponent {
    @Input() RefVerticalNavbarStyleComponent: any;
    // Private
    _variant: string;
    fuseConfig: any;
    @Input() userInfo: any;
    /**
     * Constructor
     *
     * param {ElementRef} _elementRef
     * param {Renderer2} _renderer
     */
    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2,
        private _fuseConfigService: FuseConfigService
    ) {
        // Set the private defaults
        this._variant = 'vertical-style-1';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string {
        return this._variant;
    }

    @Input()
    set variant(value: string) {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }
    ngOnInit() {
        this._fuseConfigService.config.subscribe(config => {
            this.fuseConfig = config;
        });
    }
}
